export default "__VITE_ASSET__9e23b662__"